import { defineMessages } from 'react-intl';

export default defineMessages({
	// Peacock Modals
	welcome_modal_header: {
		id: `svod_modals.welcome_modal_header`,
		defaultMessage: "Welcome to Peacock",
	},
	welcome_modal_message: {
		id: `svod_modals.welcome_modal_message`,
		defaultMessage: "Feel free to explore! As a reminder, you are previewing a simulated streaming environment, so not everything you see will be available. Take a look around and click on anything that is interesting to you! We’ll prompt you to watch a specific show in a few minutes.",
	},
	prompt_curated_content_header: {
		id: `svod_modals.prompt_curated_content_header`,
		defaultMessage: 'Did You Notice This Section?',
	},

	home_page_prompt_header: {
		id: `svod_modals.home_page_prompt_header`,
		defaultMessage: "Please Return To The Home Page",
	},
	home_page_prompt_message: {
		id: `svod_modals.home_page_prompt_message`,
		defaultMessage: 'Thanks for looking around! To continue with the study, please return to the home page by clicking the Peacock logos on the left at the top and bottom.',
	},
	home_page_prompt_watch_page_message: {
		id: `svod_modals.home_page_prompt_watch_page_message`,
		defaultMessage: 'Thanks for looking around! Please press continue to be taken back to the home screen.',
	},

	prompt_watch_page_header: {
		id: `svod_modals.prompt_watch_page_header`,
		defaultMessage: 'Please Watch The Episode',
	},

	final_step_confirmation_header: {
		id: `svod_modals.final_step_confirmation_header`,
		defaultMessage: 'You Are On The Last Step!',
	},
	final_step_confirmation_message: {
		id: `svod_modals.final_step_confirmation_message`,
		defaultMessage: 'Thanks for going through the environment! As the final step, please watch this video to the end - do not click to leave the page. After the video is ended, you will be sent to the exit survey.',
	},

	peacock_logout_modal_header: {
		id: `svod_modals.peacock_logout_modal_header`,
		defaultMessage: 'Thanks for Watching',
	},
	peacock_logout_modal_message: {
		id: `svod_modals.peacock_logout_modal_message`,
		defaultMessage: 'Thank you for watching the episode. You will now continue to the Exit Survey of the study.',
	},

	logout_of_experience: {
		id: `svod_modals.logout_of_experience`,
		defaultMessage: 'Logout of Experience',
	},

	// AppleTV Modals
	watch_page_prompt_header: {
		id: `svod_modals.watch_page_prompt_header`,
		defaultMessage: "Thanks For Exploring",
	},

	return_to_target_content_header: {
		id: `svod_modals.return_to_target_content_header`,
		defaultMessage: "Please Continue Watching",
	},
	return_to_target_content_message: {
		id: `svod_modals.return_to_target_content_message`,
		defaultMessage: 'To receive your incentive, please click "Resume Episode" to finish watching the episode.',
	},

	logout_modal_header: {
		id: `svod_modals.logout_modal_header`,
		defaultMessage: 'Thanks for Watching',
	},
	logout_modal_message: {
		id: `svod_modals.logout_modal_message`,
		defaultMessage: 'Thank you for watching the episode. You will now continue to the Exit Survey of the study.',
	},

	logout_svod_modal_message: {
		id: `svod_modals.logout_svod_modal_message`,
		defaultMessage: 'Thank you for exploring the AppleTV+ environment. You will now continue to the Exit Survey of the study.',
	},

	transaction_header: {
		id: `svod_modals.transaction_header`,
		defaultMessage: 'This content available for purchase'
	},
});


// WEBPACK FOOTER //
// ./src/locales/svodModals.js